import React, { useState } from "react";

const Svg = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  />
);

const Bar = (props) => <rect rx="0.75" fill="currentColor" {...props} />;
const Edge = (props) => <rect rx="0.7" fill="currentColor" {...props} />;
const Arrow = ({ d }) => (
  <path
    d={d}
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
  />
);

export const FlexIcons = {
  direction: {
    row: () => (
      <Svg>
        <Bar x="1.5" y="5" width="3.5" height="10" rx="1" />
        <Bar x="6.5" y="5" width="3.5" height="10" rx="1" />
        <Arrow d="M12.5 10h5M15 7.5l2.5 2.5L15 12.5" />
      </Svg>
    ),
    rowReverse: () => (
      <Svg>
        <Arrow d="M7.5 10h-5M5 7.5L2.5 10L5 12.5" />
        <Bar x="10" y="5" width="3.5" height="10" rx="1" />
        <Bar x="15" y="5" width="3.5" height="10" rx="1" />
      </Svg>
    ),
    column: () => (
      <Svg>
        <Bar x="5" y="1.5" width="10" height="3.5" rx="1" />
        <Bar x="5" y="6.5" width="10" height="3.5" rx="1" />
        <Arrow d="M10 12.5v5M7.5 15L10 17.5L12.5 15" />
      </Svg>
    ),
    columnReverse: () => (
      <Svg>
        <Arrow d="M10 7.5v-5M7.5 5L10 2.5L12.5 5" />
        <Bar x="5" y="10" width="10" height="3.5" rx="1" />
        <Bar x="5" y="15" width="10" height="3.5" rx="1" />
      </Svg>
    ),
  },

  justify: {
    start: () => (
      <Svg>
        <Edge x="2" y="3" width="1.4" height="14" />
        <Bar x="5.4" y="5.5" width="3" height="9" />
        <Bar x="9.9" y="5.5" width="3" height="9" />
      </Svg>
    ),
    center: () => (
      <Svg>
        <Edge x="9.3" y="3" width="1.4" height="14" />
        <Bar x="4.8" y="5.5" width="3" height="9" />
        <Bar x="12.2" y="5.5" width="3" height="9" />
      </Svg>
    ),
    end: () => (
      <Svg>
        <Edge x="16.6" y="3" width="1.4" height="14" />
        <Bar x="7.6" y="5.5" width="3" height="9" />
        <Bar x="12.1" y="5.5" width="3" height="9" />
      </Svg>
    ),
    between: () => (
      <Svg>
        <Edge x="2" y="3" width="1.4" height="14" />
        <Edge x="16.6" y="3" width="1.4" height="14" />
        <Bar x="5.4" y="5.5" width="3" height="9" />
        <Bar x="11.6" y="5.5" width="3" height="9" />
      </Svg>
    ),
    around: () => (
      <Svg>
        <Edge x="2" y="3" width="1.4" height="14" />
        <Edge x="16.6" y="3" width="1.4" height="14" />
        <Bar x="5.2" y="5.5" width="3" height="9" />
        <Bar x="11.8" y="5.5" width="3" height="9" />
      </Svg>
    ),
    evenly: () => (
      <Svg>
        <Edge x="2" y="3" width="1.4" height="14" />
        <Edge x="16.6" y="3" width="1.4" height="14" />
        <Bar x="5.8" y="5.5" width="3" height="9" />
        <Bar x="11.2" y="5.5" width="3" height="9" />
      </Svg>
    ),
  },

  alignItems: {
    stretch: () => (
      <Svg>
        <Edge x="3" y="3" width="14" height="1.4" />
        <Edge x="3" y="15.6" width="14" height="1.4" />
        <Bar x="6" y="5.9" width="3" height="8.2" />
        <Bar x="11" y="5.9" width="3" height="8.2" />
      </Svg>
    ),
    start: () => (
      <Svg>
        <Edge x="3" y="3" width="14" height="1.4" />
        <Bar x="6" y="5.9" width="3" height="9" />
        <Bar x="11" y="5.9" width="3" height="5.5" />
      </Svg>
    ),
    center: () => (
      <Svg>
        <Bar x="6" y="4" width="3" height="12" />
        <Bar x="11" y="6.5" width="3" height="7" />
        <Edge x="3" y="9.3" width="14" height="1.4" />
      </Svg>
    ),
    end: () => (
      <Svg>
        <Edge x="3" y="15.6" width="14" height="1.4" />
        <Bar x="6" y="5.1" width="3" height="9" />
        <Bar x="11" y="8.6" width="3" height="5.5" />
      </Svg>
    ),
    baseline: () => (
      <Svg>
        <Bar x="6" y="4.5" width="3" height="11.5" />
        <Bar x="11" y="7" width="3" height="5.5" />
        <Edge x="3" y="12.5" width="14" height="1.4" />
      </Svg>
    ),
  },

  wrap: {
    nowrap: () => (
      <Svg>
        <Bar x="3" y="5" width="3" height="10" />
        <Bar x="8.5" y="5" width="3" height="10" />
        <Bar x="14" y="5" width="3" height="10" />
      </Svg>
    ),
    wrap: () => (
      <Svg>
        <Bar x="3" y="3.5" width="4" height="5" rx="1" />
        <Bar x="8" y="3.5" width="4" height="5" rx="1" />
        <Bar x="13" y="3.5" width="4" height="5" rx="1" />
        <Bar x="3" y="11.5" width="4" height="5" rx="1" />
        <Bar x="8" y="11.5" width="4" height="5" rx="1" />
      </Svg>
    ),
    wrapReverse: () => (
      <Svg>
        <Bar x="3" y="3.5" width="4" height="5" rx="1" />
        <Bar x="8" y="3.5" width="4" height="5" rx="1" />
        <Bar x="3" y="11.5" width="4" height="5" rx="1" />
        <Bar x="8" y="11.5" width="4" height="5" rx="1" />
        <Bar x="13" y="11.5" width="4" height="5" rx="1" />
      </Svg>
    ),
  },

  alignContent: {
    stretch: () => (
      <Svg>
        <Bar x="3" y="3" width="14" height="6.2" rx="1" />
        <Bar x="3" y="10.8" width="14" height="6.2" rx="1" />
      </Svg>
    ),
    start: () => (
      <Svg>
        <Bar x="3" y="3" width="14" height="3" rx="1" />
        <Bar x="3" y="7.5" width="14" height="3" rx="1" />
      </Svg>
    ),
    center: () => (
      <Svg>
        <Bar x="3" y="6.25" width="14" height="3" rx="1" />
        <Bar x="3" y="10.75" width="14" height="3" rx="1" />
      </Svg>
    ),
    end: () => (
      <Svg>
        <Bar x="3" y="9.5" width="14" height="3" rx="1" />
        <Bar x="3" y="14" width="14" height="3" rx="1" />
      </Svg>
    ),
    between: () => (
      <Svg>
        <Bar x="3" y="3" width="14" height="3" rx="1" />
        <Bar x="3" y="14" width="14" height="3" rx="1" />
      </Svg>
    ),
    around: () => (
      <Svg>
        <Bar x="3" y="5" width="14" height="3" rx="1" />
        <Bar x="3" y="12" width="14" height="3" rx="1" />
      </Svg>
    ),
  },
};

const sized = (Icon) => {
  const Wrapped = ({ size = 18, ...rest }) => (
    <Icon width={size} height={size} {...rest} />
  );
  return Wrapped;
};

export const FLEX_ICONS = {
  flexDirection: {
    row: sized(FlexIcons.direction.row),
    column: sized(FlexIcons.direction.column),
    rowReverse: sized(FlexIcons.direction.rowReverse),
    columnReverse: sized(FlexIcons.direction.columnReverse),
  },
  justifyContent: {
    flexStart: sized(FlexIcons.justify.start),
    center: sized(FlexIcons.justify.center),
    flexEnd: sized(FlexIcons.justify.end),
    spaceBetween: sized(FlexIcons.justify.between),
    spaceAround: sized(FlexIcons.justify.around),
    spaceEvenly: sized(FlexIcons.justify.evenly),
  },
  alignItems: {
    stretch: sized(FlexIcons.alignItems.stretch),
    flexStart: sized(FlexIcons.alignItems.start),
    center: sized(FlexIcons.alignItems.center),
    flexEnd: sized(FlexIcons.alignItems.end),
    baseline: sized(FlexIcons.alignItems.baseline),
  },
  flexWrap: {
    nowrap: sized(FlexIcons.wrap.nowrap),
    wrap: sized(FlexIcons.wrap.wrap),
    wrapReverse: sized(FlexIcons.wrap.wrapReverse),
  },
  alignContent: {
    stretch: sized(FlexIcons.alignContent.stretch),
    flexStart: sized(FlexIcons.alignContent.start),
    center: sized(FlexIcons.alignContent.center),
    flexEnd: sized(FlexIcons.alignContent.end),
    spaceBetween: sized(FlexIcons.alignContent.between),
    spaceAround: sized(FlexIcons.alignContent.around),
  },
};

const SECTIONS = [
  {
    key: "flexDirection",
    title: "Direction",
    options: [
      { value: "row", Icon: FlexIcons.direction.row },
      { value: "column", Icon: FlexIcons.direction.column },
      { value: "row-reverse", Icon: FlexIcons.direction.rowReverse },
      { value: "column-reverse", Icon: FlexIcons.direction.columnReverse },
    ],
  },
  {
    key: "justifyContent",
    title: "Justify content",
    options: [
      { value: "flex-start", Icon: FlexIcons.justify.start },
      { value: "center", Icon: FlexIcons.justify.center },
      { value: "flex-end", Icon: FlexIcons.justify.end },
      { value: "space-between", Icon: FlexIcons.justify.between },
      { value: "space-around", Icon: FlexIcons.justify.around },
      { value: "space-evenly", Icon: FlexIcons.justify.evenly },
    ],
  },
  {
    key: "alignItems",
    title: "Align items",
    options: [
      { value: "stretch", Icon: FlexIcons.alignItems.stretch },
      { value: "flex-start", Icon: FlexIcons.alignItems.start },
      { value: "center", Icon: FlexIcons.alignItems.center },
      { value: "flex-end", Icon: FlexIcons.alignItems.end },
      { value: "baseline", Icon: FlexIcons.alignItems.baseline },
    ],
  },
  {
    key: "flexWrap",
    title: "Wrap",
    options: [
      { value: "nowrap", Icon: FlexIcons.wrap.nowrap },
      { value: "wrap", Icon: FlexIcons.wrap.wrap },
      { value: "wrap-reverse", Icon: FlexIcons.wrap.wrapReverse },
    ],
  },
  {
    key: "alignContent",
    title: "Align content",
    options: [
      { value: "stretch", Icon: FlexIcons.alignContent.stretch },
      { value: "flex-start", Icon: FlexIcons.alignContent.start },
      { value: "flex-end", Icon: FlexIcons.alignContent.end },
      { value: "space-between", Icon: FlexIcons.alignContent.between },
      { value: "space-around", Icon: FlexIcons.alignContent.around },
    ],
  },
];

const CSS = `
.fxc-panel{
  width:300px;background:#fff;border:1px solid #e6e8ee;border-radius:14px;
  box-shadow:0 1px 2px rgba(16,24,40,.05);overflow:hidden;
  font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
}
.fxc-section{padding:14px 16px 16px}
.fxc-section+.fxc-section{border-top:1px solid #f1f2f5}
.fxc-head{display:flex;align-items:baseline;justify-content:space-between;margin-bottom:10px}
.fxc-title{font-size:12.5px;font-weight:600;color:#5f646d;letter-spacing:.01em}
.fxc-value{font-size:10.5px;font-weight:500;color:#9298a1;font-family:ui-monospace,SFMono-Regular,Menlo,monospace}
.fxc-row{display:flex;flex-wrap:wrap;gap:6px}
.fxc-btn{
  width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;
  border-radius:9px;border:1px solid transparent;background:transparent;color:#a0a5ad;
  cursor:pointer;padding:0;transition:background .12s,color .12s,border-color .12s;
}
.fxc-btn:hover{background:#f3f4f7;color:#40454e}
.fxc-btn.is-active{background:#eef0ff;border-color:#dcdfff;color:#CCF600}
.fxc-btn.is-active:hover{background:#e6e9ff}
.fxc-btn:focus-visible{outline:2px solid #a5b4fc;outline-offset:1px}

.fxd-wrap{display:flex;flex-wrap:wrap;gap:20px;align-items:flex-start;padding:24px;
  background:#f7f8fa;min-height:100vh;box-sizing:border-box;
  font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}
.fxd-stage{flex:1;min-width:300px}
.fxd-box{
  display:flex;gap:8px;height:340px;padding:12px;box-sizing:border-box;
  background:#fff;border:1.5px dashed #cdd2db;border-radius:12px;overflow:hidden;
  transition:all .15s;
}
.fxd-item{
  display:flex;align-items:center;justify-content:center;width:48px;min-height:40px;
  background:#eef0ff;border:1px solid #dcdfff;border-radius:8px;
  color:#CCF600;font-size:13px;font-weight:600;box-sizing:border-box;flex:none;
}
.fxd-i2{min-height:58px}.fxd-i3{min-height:34px}.fxd-i4{min-height:50px}.fxd-i5{min-height:42px}
.fxd-hint{margin-top:10px;font-size:11.5px;color:#9298a1;
  font-family:ui-monospace,SFMono-Regular,Menlo,monospace}
`;

export function FlexControls({ value, onChange }) {
  return (
    <div className="fxc-panel">
      <style>{CSS}</style>
      {SECTIONS.map(({ key, title, options }) => (
        <div className="fxc-section" key={key}>
          <div className="fxc-head">
            <span className="fxc-title">{title}</span>
            <span className="fxc-value">{value[key]}</span>
          </div>
          <div className="fxc-row">
            {options.map(({ value: v, Icon }) => {
              const active = value[key] === v;
              return (
                <button
                  key={v}
                  type="button"
                  title={`${title}: ${v}`}
                  aria-pressed={active}
                  className={`fxc-btn${active ? " is-active" : ""}`}
                  onClick={() => onChange(key, v)}
                >
                  <Icon />
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

export default function FlexControlsDemo() {
  const [flex, setFlex] = useState({
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexWrap: "wrap",
    alignContent: "flex-start",
  });

  const handleChange = (key, val) =>
    setFlex((prev) => ({ ...prev, [key]: val }));

  return (
    <div className="fxd-wrap">
      <FlexControls value={flex} onChange={handleChange} />
      <div className="fxd-stage">
        <div className="fxd-box" style={{ ...flex }}>
          {[1, 2, 3, 4, 5].map((n) => (
            <div key={n} className={`fxd-item fxd-i${n}`}>
              {n}
            </div>
          ))}
        </div>
        <div className="fxd-hint">
          {`display: flex; flex-direction: ${flex.flexDirection}; justify-content: ${flex.justifyContent}; align-items: ${flex.alignItems}; flex-wrap: ${flex.flexWrap}; align-content: ${flex.alignContent};`}
        </div>
      </div>
    </div>
  );
}
